import styled, { css } from "styled-components";

export const StyledCheckCircleLabel = styled.span`
    color: var(--color-grey-900);
    font-size: var(--size-14);
    line-height: 20px;
    display: block;
    font-weight: normal;
`;

export const StyledCheckCircleContainer = styled.div<{ $disabled: boolean }>`
    display: flex;
    flex-direction: row;

    svg.checkCircle {
        width: 20px;
        height: 20px;
        margin-right: 10px;
    }

    ${(props) =>
        props.$disabled &&
        css`
            svg {
                path {
                    fill: var(--color-grey-700);
                }
            }

            ${StyledCheckCircleLabel} {
                opacity: 0.5;
            }
        `}
`;
